import { Routes, Route, useParams } from 'react-router-dom'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import LanguageRoute from './components/LanguageRoute/LanguageRoute'
import GeoLanguageRedirect from './components/GeoLanguageRedirect/GeoLanguageRedirect'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Home from './pages/Home/Home'
import About from './pages/About/About'
import Founder from './pages/Founder/Founder'
import President from './pages/President/President'
import Presidium from './pages/Presidium/Presidium'
import Representatives from './pages/Representatives/Representatives'
import MartialArts from './pages/MartialArts/MartialArts'
import Certifications from './pages/Certifications/Certifications'
import BlackBelts from './pages/BlackBelts/BlackBelts'
import ColoredBelts from './pages/ColoredBelts/ColoredBelts'
import Membership from './pages/Membership/Membership'
import Join from './pages/Join/Join'
import Schools from './pages/Schools/Schools'
import Federations from './pages/Federations/Federations'
import Events from './pages/Events/Events'
import CompetitionRules from './pages/CompetitionRules/CompetitionRules'
import ChampionsLeague from './pages/ChampionsLeague/ChampionsLeague'
import RecordBook from './pages/RecordBook/RecordBook'
import HonoraryAwards from './pages/HonoraryAwards/HonoraryAwards'
import News from './pages/News/News'
import NewsDetail from './pages/News/NewsDetail'
import Videos from './pages/Videos/Videos'
import VideoDetail from './pages/Videos/VideoDetail'
import Documents from './pages/Documents/Documents'
import Charter from './pages/Charter/Charter'
import AttestationGuidelines from './pages/AttestationGuidelines/AttestationGuidelines'
import Books from './pages/Books/Books'
import Contact from './pages/Contact/Contact'
import NotFound from './pages/NotFound/NotFound'
import './App.css'
import './components/Button/Button.css'

// Редирект новости на языковую версию по геолокации
function NewsRedirect() {
  const { newsId } = useParams()
  return <GeoLanguageRedirect path={`/news/${newsId}`} />
}

function VideosRedirect() {
  const { collectionId } = useParams()
  return <GeoLanguageRedirect path={`/videos/${collectionId}`} />
}

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <Header />
      <main className="main-content">
        <Routes>
          {/* Редирект с корня на язык по геолокации */}
          <Route path="/" element={<GeoLanguageRedirect />} />
          
          {/* Роуты с языковым префиксом */}
          <Route path="/:lang" element={
            <LanguageRoute>
              <Home />
            </LanguageRoute>
          } />
          <Route path="/:lang/about" element={
            <LanguageRoute>
              <About />
            </LanguageRoute>
          } />
          <Route path="/:lang/founder" element={
            <LanguageRoute>
              <Founder />
            </LanguageRoute>
          } />
          <Route path="/:lang/president" element={
            <LanguageRoute>
              <President />
            </LanguageRoute>
          } />
          <Route path="/:lang/presidium" element={
            <LanguageRoute>
              <Presidium />
            </LanguageRoute>
          } />
          <Route path="/:lang/representatives" element={
            <LanguageRoute>
              <Representatives />
            </LanguageRoute>
          } />
          <Route path="/:lang/martial-arts/:disciplineId?" element={
            <LanguageRoute>
              <MartialArts />
            </LanguageRoute>
          } />
          <Route path="/:lang/certifications/:disciplineId?" element={
            <LanguageRoute>
              <Certifications />
            </LanguageRoute>
          } />
          <Route path="/:lang/black-belts/:disciplineId?" element={
            <LanguageRoute>
              <BlackBelts />
            </LanguageRoute>
          } />
          <Route path="/:lang/colored-belts/:disciplineId?/:beltId?" element={
            <LanguageRoute>
              <ColoredBelts />
            </LanguageRoute>
          } />
          <Route path="/:lang/membership" element={
            <LanguageRoute>
              <Membership />
            </LanguageRoute>
          } />
          <Route path="/:lang/join" element={
            <LanguageRoute>
              <Join />
            </LanguageRoute>
          } />
          <Route path="/:lang/schools/:disciplineId?" element={
            <LanguageRoute>
              <Schools />
            </LanguageRoute>
          } />
          <Route path="/:lang/federations/:federationId?" element={
            <LanguageRoute>
              <Federations />
            </LanguageRoute>
          } />
          <Route path="/:lang/books/:disciplineId?" element={
            <LanguageRoute>
              <Books />
            </LanguageRoute>
          } />
          <Route path="/:lang/competition-rules/:disciplineId?" element={
            <LanguageRoute>
              <CompetitionRules />
            </LanguageRoute>
          } />
          <Route path="/:lang/events" element={
            <LanguageRoute>
              <Events />
            </LanguageRoute>
          } />
          <Route path="/:lang/champions-league" element={
            <LanguageRoute>
              <ChampionsLeague />
            </LanguageRoute>
          } />
          <Route path="/:lang/record-book" element={
            <LanguageRoute>
              <RecordBook />
            </LanguageRoute>
          } />
          <Route path="/:lang/honorary-awards" element={
            <LanguageRoute>
              <HonoraryAwards />
            </LanguageRoute>
          } />
          <Route path="/:lang/news" element={
            <LanguageRoute>
              <News />
            </LanguageRoute>
          } />
          <Route path="/:lang/news/:newsId" element={
            <LanguageRoute>
              <NewsDetail />
            </LanguageRoute>
          } />
          <Route path="/:lang/videos" element={
            <LanguageRoute>
              <Videos />
            </LanguageRoute>
          } />
          <Route path="/:lang/videos/:collectionId" element={
            <LanguageRoute>
              <VideoDetail />
            </LanguageRoute>
          } />
          <Route path="/:lang/documents/charter" element={
            <LanguageRoute>
              <Charter />
            </LanguageRoute>
          } />
          <Route path="/:lang/documents/attestation-guidelines" element={
            <LanguageRoute>
              <AttestationGuidelines />
            </LanguageRoute>
          } />
          <Route path="/:lang/documents" element={
            <LanguageRoute>
              <Documents />
            </LanguageRoute>
          } />
          <Route path="/:lang/contact" element={
            <LanguageRoute>
              <Contact />
            </LanguageRoute>
          } />
          {/* Редирект старых URL без языкового префикса по геолокации */}
          <Route path="/about" element={<GeoLanguageRedirect path="/about" />} />
          <Route path="/founder" element={<GeoLanguageRedirect path="/founder" />} />
          <Route path="/president" element={<GeoLanguageRedirect path="/president" />} />
          <Route path="/presidium" element={<GeoLanguageRedirect path="/presidium" />} />
          <Route path="/representatives" element={<GeoLanguageRedirect path="/representatives" />} />
          <Route path="/martial-arts" element={<GeoLanguageRedirect path="/martial-arts" />} />
          <Route path="/certifications" element={<GeoLanguageRedirect path="/certifications" />} />
          <Route path="/black-belts" element={<GeoLanguageRedirect path="/black-belts" />} />
          <Route path="/colored-belts" element={<GeoLanguageRedirect path="/colored-belts" />} />
          <Route path="/membership" element={<GeoLanguageRedirect path="/membership" />} />
          <Route path="/join" element={<GeoLanguageRedirect path="/join" />} />
          <Route path="/schools" element={<GeoLanguageRedirect path="/schools" />} />
          <Route path="/federations" element={<GeoLanguageRedirect path="/federations" />} />
          <Route path="/events" element={<GeoLanguageRedirect path="/events" />} />
          <Route path="/competition-rules" element={<GeoLanguageRedirect path="/competition-rules" />} />
          <Route path="/champions-league" element={<GeoLanguageRedirect path="/champions-league" />} />
          <Route path="/record-book" element={<GeoLanguageRedirect path="/record-book" />} />
          <Route path="/honorary-awards" element={<GeoLanguageRedirect path="/honorary-awards" />} />
          <Route path="/news" element={<GeoLanguageRedirect path="/news" />} />
          <Route path="/news/:newsId" element={<NewsRedirect />} />
          <Route path="/videos" element={<GeoLanguageRedirect path="/videos" />} />
          <Route path="/videos/:collectionId" element={<VideosRedirect />} />
          <Route path="/documents/charter" element={<GeoLanguageRedirect path="/documents/charter" />} />
          <Route path="/documents/attestation-guidelines" element={<GeoLanguageRedirect path="/documents/attestation-guidelines" />} />
          <Route path="/documents" element={<GeoLanguageRedirect path="/documents" />} />
          <Route path="/books" element={<GeoLanguageRedirect path="/books" />} />
          <Route path="/contact" element={<GeoLanguageRedirect path="/contact" />} />
          
          <Route path="*" element={
            <LanguageRoute>
              <NotFound />
            </LanguageRoute>
          } />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App
